module.exports = __webpack_public_path__ + "static/media/report-illustration.0828b528.svg";